// extracted by mini-css-extract-plugin
export default {"tooltip":"picker-input-field-module__tooltip--nb6jK"};